// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../icon';
import apiUrl from '../../configs/constant';
import MsiDatagrid from '../custom/MsiDatagridAuto';

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormHelperText,
    Typography,
} from '@mui/material'

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { Controller, useForm } from 'react-hook-form'
import { useToast } from '../ToastProvider'
import { on } from 'events'
import { getDoctag, getGudang } from '../../api/helper'
import appInfo from '../../configs/app-info'

interface Props {
    mmgudangId?: number | string | null;
}
export default function Index({ mmgudangId }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const token = userData.token

    const { showToast, hideToast } = useToast();

    // ** State
    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])
    const [listSubGudang, setListSubGudang] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)

    useEffect(() => {
        getData()
        getSubGudang(mmgudangId)
    }, [mmgudangId])

    const navigate = useNavigate();

    const getData = () => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        let url = apiUrl.apiUrl + '/gudang/stock-opname/list-opname';

        axios
            .get(url, {
                params: { mmgudang_id: mmgudangId, tgl_awal: tglAwal, tgl_akhir: tglAkhir },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getSubGudang = (gudangId: any) => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
            .get(url, {
                params: { mmgudang_id: gudangId },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSubGudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const convertComponent = [
        {
            key: 'posting',
            renderCell: ({ row }: any) => (
                <>
                    {row.data.posting == 1 ? (
                        <Button
                            variant='contained'
                            color='error'
                            startIcon={<Icon icon='mdi:close-circle' />}
                            onClick={() => postingOpname(row.data.id, 0)}
                        >
                            BATAL POSTING
                        </Button>
                    ) : (

                        <Button
                            variant='contained'
                            startIcon={<Icon icon='mdi:check-circle' />}
                            onClick={() => postingOpname(row.data.id, 1)}
                        >
                            POSTING
                        </Button>
                    )}
                </>
            )
        }
    ]

    interface FormInputs {
        mmgudang_id: number | string | null;
        mmgudang_sub_id: number;
        keterangan: string;
        pic: string;
        sysdoctag_id: any
    }

    const defaultValues = {
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const data = {}
                const url = apiUrl.apiUrl + '/gudang/stock-opname/delete-opname/' + row.id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const ActionButtons = ({
        row,
        onDelete,
        onNavigate
    }: {
        row: any
        onDelete: (row: any) => void
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: 'Lihat Detail',
                icon: 'mdi:search',
                color: '#0984e3', // biru terang seperti "primary"
                onClick: () => onNavigate(row.id)
            },
            {
                title: 'Hapus Opname',
                icon: 'mdi:trash',
                color: '#d63031', // merah terang seperti "error"
                onClick: () => onDelete(row)
            },
            {
                title: 'Download Excel',
                icon: 'mdi:file-excel',
                color: '#10ac84',
                href: `${apiUrl.baseUrl}/warehouse/gudang/detail-opname-excel/${row.id}`,
                target: '_blank'
            },
            {
                title: 'Download PDF',
                icon: 'mdi:file-pdf',
                color: '#e73e33',
                href: `${apiUrl.baseUrl}/warehouse/gudang/detail-opname-pdf/${row.id}`,
                target: '_blank'
            }
        ]

        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement='top'>
                        {action.href ? (
                            <a
                                href={action.href}
                                target={action.target || '_self'}
                                rel='noopener noreferrer'
                                style={{ textDecoration: 'none' }}
                            >
                                <IconButton component='span'>
                                    <Icon icon={action.icon} color={action.color} />
                                </IconButton>
                            </a>
                        ) : (
                            <a
                                onClick={action.onClick}
                                style={{ cursor: 'pointer', textDecoration: 'none' }}
                            >
                                <IconButton component='span'>
                                    <Icon icon={action.icon} color={action.color} />
                                </IconButton>
                            </a>
                        )}
                    </Tooltip>
                ))}
            </Box>
        )
    }

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 200,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/gudang/view-opname/' + id)}
                />
            ),
        },
    ];

    const postingOpname = (ids: any, mode: any) => {
        let btnText = ''
        if (mode == 0) {
            btnText = 'Batal Posting'
        } else {
            btnText = 'Posting'
        }

        Swal.fire({
            title: 'Konfirmasi',
            text: `Apakah anda ingin ${btnText} data ini ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: btnText
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const data = {
                    mode: mode,
                    sysdoctag_id: 12510000010
                }

                const url = apiUrl.apiUrl + '/gudang/stock-opname/posting-opname/' + ids
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <Divider />
                <Box
                    sx={{
                        mt: 2,
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}
                >
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        {/* <CardHeader title='SALES ORDER' /> */}
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                        {/* <Fab color='primary' size='medium' onClick={() => navigate('/sales/sales-order/add')} */}
                        <Fab color='primary' size='medium' onClick={() => setOpenDialog(true)}>
                            <Icon icon='mdi:plus' fontSize={35} color='white' />
                        </Fab>
                    </Box>
                </Box>
                <Box>
                    <Grid
                        container
                        sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                        spacing={5}
                    >
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Awal'
                                    type='date'
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    value={tglAwal}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>

                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    value={tglAkhir}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth>
                                <Button
                                    variant='contained'
                                    sx={{ mt: 1 }}
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={() => getData()}
                                >
                                    Cari Data
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
                <MsiDatagrid array={listData} actions={actionData} hiddenColumns={['mmgudang_id']} customRender={convertComponent} />
            </Grid>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = apiUrl.apiUrl + '/gudang/stock-opname/save-opname';

                    axios.post(url, {
                        mmgudang_sub_id: data.mmgudang_sub_id,
                        mmgudang_id: mmgudangId,
                        pic: data.pic,
                        keterangan: data.keterangan,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialog(false);
                                navigate('/gudang/view-opname/' + response.data.data);
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialog(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Buat Stock Opname
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Gudang</InputLabel>
                                    <Controller
                                        name='mmgudang_sub_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Sub Gudang'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.mmgudang_sub_id)}
                                            >
                                                {listSubGudang.map((item: any, index: any) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmgudang_sub_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.pic && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                multiline
                                                rows={3}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.keterangan && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid>
    )
}
